module.exports = __webpack_public_path__ + "img/hospitality-section23.41eb8c03.svg";